import getSellerNotifications from "storefront/GrailedAPI/v1/Users/SellerNotifications/getSellerNotifications";
import { Id } from "storefront/lib/Id";
import useData from "./data/useData";

const useSellerNotifications = (userId: Id) => {
  return useData(getSellerNotifications, {
    args: [userId],
  });
};
export default useSellerNotifications;
